<template>
  <button type="button" aria-label="Close" @click="onClose">
    <!-- drawn, not the ✕ character (2026-10-14): a font's glyph sits differently in each browser,
         so it couldn't be centred in the round button everywhere -->
    <svg class="close-icon" viewBox="0 0 18 18" aria-hidden="true">
      <path d="M1 1L17 17M17 1L1 17" />
    </svg>
  </button>
</template>

<script setup>
defineProps({
  onClose: {type: Function, required: true}
});
</script>

<style scoped>
button {
  background: transparent;
  border: none;
  box-shadow: none;
  border-radius: 0;
  cursor: pointer;
  padding: 0;
  margin: 0;
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
}
.close-icon {
  display: block;
  width: 18px;
  height: 18px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.6;
}
button:focus {
  outline: none;
}
/* keyboard focus only (2026-10-14): a ring that follows the button's circle (Dialog/Header.vue) */
button:focus-visible {
  outline: 2px solid var(--brand-dark-color);
  outline-offset: 2px;
}
button:hover {
  opacity: 0.55;
}
</style>
